import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import TextInput from './TextInput';
import { colors, transition } from '../tokens';

// PasswordInput — TextInput chuyên cho mật khẩu kèm nút eye toggle.
// Mặc định autoComplete='new-password' (override qua prop nếu cần
// dùng cho ô login mật khẩu hiện tại).
const PasswordInput = forwardRef(function PasswordInput(
  { autoComplete = 'new-password', ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? AiOutlineEyeInvisible : AiOutlineEye;

  return (
    <TextInput
      ref={ref}
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      rightIcon={
        <EyeButton
          type='button'
          onClick={() => setVisible((v) => !v)}
          disabled={props.disabled}
          aria-label={visible ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
          tabIndex={-1}
        >
          <Icon size={18} />
        </EyeButton>
      }
      {...props}
    />
  );
});

const EyeButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0 4px;
  color: ${colors.gray500};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: ${transition.fast};

  &:hover:not(:disabled) {
    color: ${colors.gray700};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default PasswordInput;
